<template>
<nav class="navbar navbar-default" id="navbar-vue">
  <div class="container-fluid">    
    <!-- <h2>technorank | DELab</h2> -->
    <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
      <ul class="nav navbar-nav">
        <li v-for="route in routes" v-if="route.show_navbar">
          <router-link :to="route" active-class="active">
           {{ route.title }}
          </router-link>
        </li>
      </ul>
    </div><!-- /.navbar-collapse -->
  </div><!-- /.container-fluid -->
</nav>
</template>

<script>
import Routes from '@/routes'

export default {
  name: 'app',
  props: ['title'],
  data () {
    return {
      routes: Routes
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/navbar-1.vue